import React from "react";
import CategoryContainer from "./CategoryContainer";
import Avatar from "../Avatar/Avatar";
import IconComponent from "../Icons/IconComponent";
import StatusPairing from "../Status/StatusPairing";
import DateSideBar from "./DateSideBar";
import SeasonalAppLogo from "./SeasonalAppLogo";

const Sidebar = ({ minify, entries, onOpenSideBar, onOpenUserModal, onOpenLinkPortalModal, colorStatusPairing, iconStatusPairing, userAvatar, ShellHeaderLogo }) => {
    const [shouldStayOpen, setshouldStayOpen] = React.useState(true);

    if (!entries || !entries.categoryBoxes) {return null;}
    return <div style={{ margin: "20px", height: "calc(100% - 40px)", display: "block", position: "relative" }}>
        <SeasonalAppLogo ShellHeaderLogo={ShellHeaderLogo} minify={minify} />
        <span style={{ display: "flex", height: "20px" }}></span>
        <div className="box-sideBar" style={{ overflowY: "auto", overflowX: "hidden", display: "inline-flex", flexDirection: "column", alignItems: "flex-end", flexShrink: 0, maxHeight: "calc(100% - 80px)", width: "100%", scrollbarGutter: "stable" }}>
            {
                entries.categoryBoxes.map((catbox, index) => {
                    if (!catbox.hasPermission) {return null;}
                    return (
                        <div
                            className="categoryBox"
                            key={catbox.title ?? catbox.name ?? index}
                            style={{ width: "100%", marginRight: minify ? "0px" : "0px" }}
                        >
                            {
                                catbox.containers ? catbox.containers.map((container) => {
                                    if (!container.hasPermission) {return null;}
                                    return <CategoryContainer key={container.name}
                                        minify={minify}
                                        isOpen={container.isOpen}
                                        catChildrens={container.children}
                                        name={container.name}
                                        currentMenuName={entries.currentMenuName}
                                        specialItem={container.specialItem}
                                        onSelectCategory={(param) => {
                                            if (container.children && container.children.length > 0) {
                                                onOpenSideBar(true);
                                            }
                                            else if (shouldStayOpen) {
                                                onOpenSideBar(true);
                                            }
                                            else {
                                                onOpenSideBar(false);
                                            }
                                            container.onSelect(param);
                                        }}
                                        onSelectCategoryChild={() => {
                                            if (shouldStayOpen) {
                                                onOpenSideBar(true);
                                            }
                                            else {
                                                onOpenSideBar(false);
                                            }
                                        }}
                                    />;
                                }) : null
                            }
                        </div>
                    );
                })
            }
        </div>
        {
            !minify ?
                <DateSideBar />
                : null
        }
        <div className="sidebar-button-container" style={{ position: "absolute", bottom: "6px", right: minify ? "10px" : "0px", transform: minify ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.5s cubic-bezier(0.4, 0, 0.6, 1)", transitionDelay: minify ? "0.1s" : "0s" }}>
            <div style={{ cursor: "pointer" }} onClick={() => {
                onOpenSideBar(minify);
                setshouldStayOpen(!shouldStayOpen);
            }}>
                <IconComponent dimensions="24" nameIcon="sidebarCollapse" color={"grey"} />
            </div>
        </div>
        <div className="sidebar-avatar-container" style={{ position: "absolute", bottom: minify ? "56px" : "0px", left: minify ? "3px" : "0px", display: "flex", flexDirection: minify ? "column" : "row" }}>
            <Avatar
                href={userAvatar}
                onClick={() => onOpenUserModal()}
            />
            <StatusPairing colorStatusPairing={colorStatusPairing} onClick={() => {onOpenLinkPortalModal();}} iconStatusPairing={iconStatusPairing} />
        </div>
    </div>;
};

export default Sidebar;
